// Add any constants to be used throughout React App
export const WIDTH_SM = 768;
export const CLIPPER_DEFAULT_URL =
  'https://tii.imgix.net/production/articles/2763/1fd19665-7c7a-4832-966a-c1d2692a290c.jpg';
export const EMAIL_REGEX = /^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,4}$/;

export const PARTNERSHIP_FORM_URL = 'https://ti.theinformation.com/partners';
export const PARTNERSHIP_IMAGE_URL = 'https://tii.imgix.net/global/partners/partnership.png';
export const PARTNER_OG_IMAGE_PATH = '/global/og_images/partners_cover.png';
export const MEDIA_KIT_URL = 'https://theinformation.docsend.com/view/5epwkitsvgqphfgw';
export const CORPORATE_SUBSCRIPTION_FORM_URL = 'https://ti.theinformation.com/corporate';
export const EMAIL_MESSAGE_CONFIRMATION =
  'Your settings have been successfully updated. Check your inbox to verify your email.';
